module.exports = __webpack_public_path__ + "img/interface-mobile.5d93bc03.png";